import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * `?client=<clientTenantId>`: open the book focused on ONE client.
 *
 * Round 11 (NEW-FICA-VERIFY-DEADENDS): the FICA pipeline's row action used to
 * drop the operator on the bare book, which discarded the trust they had
 * picked. It now carries the owning client's tenant id here, so the row with
 * the act-as door is the one thing on screen.
 *
 * A tenant id is a UUID; anything longer or of another type is dropped rather
 * than passed through, so a hand-typed value cannot seed the filter with junk.
 */
function validateClientBookSearch(
  search: Record<string, unknown>,
): { client?: string } {
  const raw = search['client'];
  if (typeof raw !== 'string') return {};
  const trimmed = raw.trim();
  if (trimmed.length === 0 || trimmed.length > 64) return {};
  return { client: trimmed };
}

export const Route = createFileRoute('/admin/client-book')({
  component: lazyRouteComponent(() => import('./client-book-screen'), 'ClientBook'),
  validateSearch: validateClientBookSearch,
});
